<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div col-sm-6">
      <h5 class="mt-3 mb-3"> Demo License </h5><br><br>
      <b-form @submit.prevent="demoLicence('formRegistration')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration">
        <b-form-group id="nameGroup" v-if="!commercialOnly && !officeUser">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Customer Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="customerName"
                        name="customerName"
                        type="text"
                        v-model="customerName"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.customerName') }"
                        placeholder="Customer Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.customerName')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.customerName')"
                  class="help is-danger">{{ errors.first('formRegistration.customerName') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Store Id</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="storeId"
                        name="storeId"
                        type="number"
                        min=0
                        v-model="storeId"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.storeId') }"
                        placeholder="Store ID">
            </b-form-input>
            <i v-show="errors.has('formRegistration.storeId')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.storeId')"
                  class="help is-danger">{{ errors.first('formRegistration.storeId') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Store Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="storeName"
                        name="storeName"
                        type="text"
                        v-model="storeName"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.storeName') }"
                        placeholder="Store Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.storeName')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.storeName')"
                  class="help is-danger">{{ errors.first('formRegistration.storeName') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Country</label>
            </b-col>
            <b-col sm="8">
              <b-form-select id="country"
                             name="country"
                             v-model="country"
                             :options="countries"
                             v-validate="'required'"
                             :class="{'input': true,
                                      'is-danger': errors.has('formRegistration.country') }"
                             required> </b-form-select>
              <i v-show="errors.has('formRegistration.country')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.country')"
                    class="help is-danger">{{ errors.first('formRegistration.country') }}
              </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Product Key</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="productKey"
                        name="productKey"
                        type="text"
                        v-model="productKey"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.productKey') }"
                        placeholder="Product Key">
            </b-form-input>
            <i v-show="errors.has('formRegistration.productKey')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.productKey')"
                  class="help is-danger">{{ errors.first('formRegistration.productKey') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showProducts || showPeopleCounterOverhead || notShowPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> Type</label>
            </b-col>
          <b-col sm="8">
            <b-form-select
                           v-model="licenceType"
                           name="licenceType"
                           v-validate="'required'">
                           <option value="null"> Select Type </option>
                           <option v-for="(list, index) in options"
                                   v-bind:key="index"
                                   :value="{type: list.type, id: list.id}">
                                   {{ list.type }}
                           </option>
            </b-form-select>
            <i v-show="errors.has('formRegistration.licenceType')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.licenceType')"
                  class="help is-danger">{{ errors.first('formRegistration.licenceType') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="(showProducts || showPeopleCounterOverhead) && licenceType && licenceType.id === 2">
            <b-col sm="4">
              <label for="input-small"> Duration</label>
            </b-col>
          <b-col sm="8">
            <b-form-select
                           v-model="expiryMonth"
                           name="expiryMonth"
                           v-validate="'required'">
                           <option value="null"> Select Duration </option>
                           <option v-for="(list, index) in expiryOptions"
                                   v-bind:key="index"
                                   :value="{days: list.days, id: list.id}">
                                   {{ list.days }}
                           </option>
            </b-form-select>
            <i v-show="errors.has('formRegistration.expiryMonth')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.expiryMonth')"
                  class="help is-danger">{{ errors.first('formRegistration.expiryMonth') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="notShowPeopleCounterOverhead && licenceType && licenceType.id === 2">
            <b-col sm="4">
              <label for="input-small"> Duration</label>
            </b-col>
          <b-col sm="8">
            <b-form-select
                           v-model="expiryMonth"
                           name="expiryMonth"
                           v-validate="'required'">
                           <option value="null"> Select Duration </option>
                           <option v-for="(list, index) in expiryOptions2"
                                   v-bind:key="index"
                                   :value="{days: list.days, id: list.id}">
                                   {{ list.days }}
                           </option>
            </b-form-select>
            <i v-show="errors.has('formRegistration.expiryMonth')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.expiryMonth')"
                  class="help is-danger">{{ errors.first('formRegistration.expiryMonth') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> Video Analytics Licenses</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="videoAnalytics"
                        name="videoAnalytics"
                        type="number"
                        min=0
                        v-model="videoAnalytics"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.videoAnalytics') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.videoAnalytics')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.videoAnalytics')"
                  class="help is-danger">{{ errors.first('formRegistration.videoAnalytics') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showPeopleCounterOverhead && !notShowPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter OverHead</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="PeopleCounterOverHead"
                        name="PeopleCounterOverHead"
                        type="number"
                        min=0
                        v-model="PeopleCounterOverHead"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.PeopleCounterOverHead') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.PeopleCounterOverHead')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.PeopleCounterOverHead')"
                  class="help is-danger">{{ errors.first('formRegistration.PeopleCounterOverHead') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showPeopleCounterOverhead || notShowPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter New</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="peopleCounterNew"
                        name="peopleCounterNew"
                        type="number"
                        min=0
                        v-model="peopleCounterNew"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.peopleCounterNew') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.peopleCounterNew')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.peopleCounterNew')"
                  class="help is-danger">{{ errors.first('formRegistration.peopleCounterNew') }}
            </span>
            </b-col>
          </b-row>
          <!-- <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> Heatmap</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="heatMap"
                        name="heatMap"
                        type="number"
                        v-model="heatMap"
                        min = 0
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.heatMap') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.heatMap')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.heatMap')"
                  class="help is-danger">{{ errors.first('formRegistration.heatMap') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> QueueManager Kiosk</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="queueManager"
                        name="queueManager"
                        type="number"
                        min = 0
                        v-model="queueManager"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.queueManager') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.queueManager')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.queueManager')"
                  class="help is-danger">{{ errors.first('formRegistration.queueManager') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> False Direction</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="falseDirection"
                        name="falseDirection"
                        type="number"
                        min=0
                        v-model="falseDirection"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.falseDirection') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.falseDirection')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.falseDirection')"
                  class="help is-danger">{{ errors.first('formRegistration.falseDirection') }}
            </span>
            </b-col>
          </b-row> -->
          <b-row class="my-1" v-if="showPeopleCounterOverhead && !notShowPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> Installation Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="installationDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
            <i v-show="errors.has('formRegistration.installationDate')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.installationDate')"
                  class="help is-danger">{{ errors.first('formRegistration.installationDate') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showPeopleCounterOverhead && !notShowPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> Go Live Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="goLiveDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
            <i v-show="errors.has('formRegistration.goLiveDate')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.goLiveDate')"
                  class="help is-danger">{{ errors.first('formRegistration.goLiveDate') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup" v-if="commercialOnly && !officeUser">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Customer Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="customerName"
                        name="customerName"
                        type="text"
                        v-model="customerName"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.customerName') }"
                        placeholder="Customer Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.customerName')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.customerName')"
                  class="help is-danger">{{ errors.first('formRegistration.customerName') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Store Id</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="storeId"
                        name="storeId"
                        type="number"
                        min=0
                        v-model="storeId"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.storeId') }"
                        placeholder="Store ID">
            </b-form-input>
            <i v-show="errors.has('formRegistration.storeId')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.storeId')"
                  class="help is-danger">{{ errors.first('formRegistration.storeId') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Store Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="storeName"
                        name="storeName"
                        type="text"
                        v-model="storeName"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.storeName') }"
                        placeholder="Store Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.storeName')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.storeName')"
                  class="help is-danger">{{ errors.first('formRegistration.storeName') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Country</label>
            </b-col>
            <b-col sm="8">
              <b-form-select id="country"
                             name="country"
                             v-model="country"
                             :options="countries"
                             v-validate="'required'"
                             :class="{'input': true,
                                      'is-danger': errors.has('formRegistration.country') }"
                             required> </b-form-select>
              <i v-show="errors.has('formRegistration.country')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.country')"
                    class="help is-danger">{{ errors.first('formRegistration.country') }}
              </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Product Key</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="productKey"
                        name="productKey"
                        type="text"
                        v-model="productKey"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.productKey') }"
                        placeholder="Product Key">
            </b-form-input>
            <i v-show="errors.has('formRegistration.productKey')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.productKey')"
                  class="help is-danger">{{ errors.first('formRegistration.productKey') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Type</label>
            </b-col>
          <b-col sm="8">
            <b-form-select
                           v-model="licenceType"
                           name="licenceType"
                           v-validate="'required'">
                           <option value="null"> Select Type </option>
                           <option v-for="(list, index) in commercialOptions"
                                   v-bind:key="index"
                                   :value="{type: list.type, id: list.id}">
                                   {{ list.type }}
                           </option>
            </b-form-select>
            <i v-show="errors.has('formRegistration.licenceType')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.licenceType')"
                  class="help is-danger">{{ errors.first('formRegistration.licenceType') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter Perspective</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="PeopleCounterPerspective"
                        name="PeopleCounterPerspective"
                        type="number"
                        min=0
                        v-model="PeopleCounterPerspective"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.PeopleCounterPerspective') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.PeopleCounterPerspective')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.PeopleCounterPerspective')"
                  class="help is-danger">{{ errors.first('formRegistration.PeopleCounterPerspective') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter OverHead</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="PeopleCounterOverHead"
                        name="PeopleCounterOverHead"
                        type="number"
                        min=0
                        v-model="PeopleCounterOverHead"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.PeopleCounterOverHead') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.PeopleCounterOverHead')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.PeopleCounterOverHead')"
                  class="help is-danger">{{ errors.first('formRegistration.PeopleCounterOverHead') }}
            </span>
            </b-col>
          </b-row>
          <!--<b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter New</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="peopleCounterNew"
                        name="peopleCounterNew"
                        type="number"
                        min=0
                        v-model="peopleCounterNew"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.peopleCounterNew') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.peopleCounterNew')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.peopleCounterNew')"
                  class="help is-danger">{{ errors.first('formRegistration.peopleCounterNew') }}
            </span>
            </b-col>
          </b-row>
           <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> Heatmap</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="heatMap"
                        name="heatMap"
                        type="number"
                        v-model="heatMap"
                        min = 0
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.heatMap') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.heatMap')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.heatMap')"
                  class="help is-danger">{{ errors.first('formRegistration.heatMap') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> QueueManager Kiosk</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="queueManager"
                        name="queueManager"
                        type="number"
                        min = 0
                        v-model="queueManager"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.queueManager') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.queueManager')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.queueManager')"
                  class="help is-danger">{{ errors.first('formRegistration.queueManager') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=showProducts>
            <b-col sm="4">
              <label for="input-small"> False Direction</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="falseDirection"
                        name="falseDirection"
                        type="number"
                        min=0
                        v-model="falseDirection"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.falseDirection') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.falseDirection')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.falseDirection')"
                  class="help is-danger">{{ errors.first('formRegistration.falseDirection') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Installation Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="installationDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
            <i v-show="errors.has('formRegistration.installationDate')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.installationDate')"
                  class="help is-danger">{{ errors.first('formRegistration.installationDate') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> Go Live Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="goLiveDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
            <i v-show="errors.has('formRegistration.goLiveDate')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.goLiveDate')"
                  class="help is-danger">{{ errors.first('formRegistration.goLiveDate') }}
            </span>
            </b-col>
          </b-row>-->
        </b-form-group>
        <b-form-group id="nameGroup" v-if=officeUser>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Customer Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="customerName"
                        name="customerName"
                        type="text"
                        v-model="customerName"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.customerName') }"
                        placeholder="Customer Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.customerName')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.customerName')"
                  class="help is-danger">{{ errors.first('formRegistration.customerName') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Store Id</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="storeId"
                        name="storeId"
                        type="number"
                        min=0
                        v-model="storeId"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.storeId') }"
                        placeholder="Store ID">
            </b-form-input>
            <i v-show="errors.has('formRegistration.storeId')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.storeId')"
                  class="help is-danger">{{ errors.first('formRegistration.storeId') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Store Name</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="storeName"
                        name="storeName"
                        type="text"
                        v-model="storeName"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.storeName') }"
                        placeholder="Store Name">
            </b-form-input>
            <i v-show="errors.has('formRegistration.storeName')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.storeName')"
                  class="help is-danger">{{ errors.first('formRegistration.storeName') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Country</label>
            </b-col>
            <b-col sm="8">
              <b-form-select id="country"
                             name="country"
                             v-model="country"
                             :options="countries"
                             v-validate="'required'"
                             :class="{'input': true,
                                      'is-danger': errors.has('formRegistration.country') }"
                             required> </b-form-select>
              <i v-show="errors.has('formRegistration.country')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.country')"
                    class="help is-danger">{{ errors.first('formRegistration.country') }}
              </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Product Key</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="productKey"
                        name="productKey"
                        type="text"
                        v-model="productKey"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.productKey') }"
                        placeholder="Product Key">
            </b-form-input>
            <i v-show="errors.has('formRegistration.productKey')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.productKey')"
                  class="help is-danger">{{ errors.first('formRegistration.productKey') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Type</label>
            </b-col>
          <b-col sm="8">
            <b-form-select
                           v-model="licenceType"
                           name="licenceType"
                           v-validate="'required'">
                           <option value="null"> Select Type </option>
                           <option v-for="(list, index) in options"
                                   v-bind:key="index"
                                   :value="{type: list.type, id: list.id}">
                                   {{ list.type }}
                           </option>
            </b-form-select>
            <i v-show="errors.has('formRegistration.licenceType')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.licenceType')"
                  class="help is-danger">{{ errors.first('formRegistration.licenceType') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="(officeUser) && licenceType && licenceType.id === 2">
            <b-col sm="4">
              <label for="input-small"> Duration</label>
            </b-col>
          <b-col sm="8">
            <b-form-select
                           v-model="expiryMonth"
                           name="expiryMonth"
                           v-validate="'required'">
                           <option value="null"> Select Duration </option>
                           <option v-for="(list, index) in expiryOptions"
                                   v-bind:key="index"
                                   :value="{days: list.days, id: list.id}">
                                   {{ list.days }}
                           </option>
            </b-form-select>
            <i v-show="errors.has('formRegistration.expiryMonth')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.expiryMonth')"
                  class="help is-danger">{{ errors.first('formRegistration.expiryMonth') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter Perspective</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="PeopleCounterPerspective"
                        name="PeopleCounterPerspective"
                        type="number"
                        min=0
                        v-model="PeopleCounterPerspective"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.PeopleCounterPerspective') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.PeopleCounterPerspective')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.PeopleCounterPerspective')"
                  class="help is-danger">{{ errors.first('formRegistration.PeopleCounterPerspective') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter OverHead</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="PeopleCounterOverHead"
                        name="PeopleCounterOverHead"
                        type="number"
                        min=0
                        v-model="PeopleCounterOverHead"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.PeopleCounterOverHead') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.PeopleCounterOverHead')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.PeopleCounterOverHead')"
                  class="help is-danger">{{ errors.first('formRegistration.PeopleCounterOverHead') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> PeopleCounter New</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="peopleCounterNew"
                        name="peopleCounterNew"
                        type="number"
                        min=0
                        v-model="peopleCounterNew"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.peopleCounterNew') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.peopleCounterNew')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.peopleCounterNew')"
                  class="help is-danger">{{ errors.first('formRegistration.peopleCounterNew') }}
            </span>
            </b-col>
          </b-row>
           <b-row class="my-1" v-if=officeUser>
            <b-col sm="4">
              <label for="input-small"> Heatmap</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="heatMap"
                        name="heatMap"
                        type="number"
                        v-model="heatMap"
                        min = 0
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.heatMap') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.heatMap')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.heatMap')"
                  class="help is-danger">{{ errors.first('formRegistration.heatMap') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=officeUser>
            <b-col sm="4">
              <label for="input-small"> QueueManager Kiosk</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="queueManager"
                        name="queueManager"
                        type="number"
                        min = 0
                        v-model="queueManager"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.queueManager') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.queueManager')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.queueManager')"
                  class="help is-danger">{{ errors.first('formRegistration.queueManager') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if=officeUser>
            <b-col sm="4">
              <label for="input-small"> False Direction</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="falseDirection"
                        name="falseDirection"
                        type="number"
                        min=0
                        v-model="falseDirection"
                        v-validate="'required'"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.falseDirection') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.falseDirection')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.falseDirection')"
                  class="help is-danger">{{ errors.first('formRegistration.falseDirection') }}
            </span>
            </b-col>
          </b-row>
          <!-- <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Installation Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="installationDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
            <i v-show="errors.has('formRegistration.installationDate')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.installationDate')"
                  class="help is-danger">{{ errors.first('formRegistration.installationDate') }}
            </span>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showPeopleCounterOverhead">
            <b-col sm="4">
              <label for="input-small"> Go Live Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="goLiveDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
            <i v-show="errors.has('formRegistration.goLiveDate')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.goLiveDate')"
                  class="help is-danger">{{ errors.first('formRegistration.goLiveDate') }}
            </span>
            </b-col> -->
          </b-row>
        </b-form-group>
        <b-button
          type="submit"
          class="w-100"
          variant="warning">Submit</b-button>
      </b-form><br>
    </div>
    <div class = "profile-div col-12">
    <b-table  striped hover v-if="!showPeopleCounterOverhead && !commercialOnly && !notShowPeopleCounterOverhead"
              :fields="fields"
              :items="licence">
              <template slot="download" slot-scope="data">
                <i @click="generateLicence(data.item.licenceKey)" title="Download License Key">
                  <v-icon name="download" base-class="icon-width" @click="generateLicence(data.item.licenceKey)">
                  </v-icon>
                </i>
              </template>
    </b-table>
    <b-table  striped hover v-if="showPeopleCounterOverhead && !commercialOnly && !notShowPeopleCounterOverhead"
              :fields="fields2"
              :items="licence">
              <template slot="link" slot-scope="data">
                <i @click="getDetail(data.item.id, data.item.userId)" title="Update Installation Date">
                  <v-icon name="edit" base-class="icon-width" @click="getDetail(data.item.id, data.item.userId)">
                  </v-icon>
                </i>
              </template>
              <template slot="download" slot-scope="data">
                <i @click="generateLicence(data.item.licenceKey)" title="Download License Key">
                  <v-icon name="download" base-class="icon-width" @click="generateLicence(data.item.licenceKey)">
                  </v-icon>
                </i>
              </template>
    </b-table>
    <b-table  striped hover v-if="commercialOnly || notShowPeopleCounterOverhead"
              :fields="fields3"
              :items="licence">
              <template slot="download" slot-scope="data">
                <i @click="generateLicence(data.item.licenceKey)" title="Download License Key">
                  <v-icon name="download" base-class="icon-width" @click="generateLicence(data.item.licenceKey)">
                  </v-icon>
                </i>
              </template>
    </b-table>

    <b-modal v-model="userSettingsModal" hide-footer title="Update Installation Date">
      <b-form @submit.prevent="updateInstallationDate('formRegistration2')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration2">
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Installation Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="newInstallationDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
          </b-col>
          </b-row>
        </b-form-group>

        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Go Live Date</label>
            </b-col>
          <b-col sm="8">
            <v-date-picker
                mode="single"
                v-model="newGoLiveDate"
                color="blue"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :masks="{ title: 'MMM YYYY', L: 'DD-MM-YYYY' }"
            />
          </b-col>
          </b-row>
        </b-form-group>

        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small">Store Id</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="newStoreId"
                        name="newStoreId"
                        type="number"
                        min=0
                        v-model="newStoreId"
                        placeholder="Store ID">
            </b-form-input>
          </b-col>
          </b-row>
        </b-form-group>

        <b-button
          type="submit"
          class="w-100"
          variant="warning">Update</b-button>
      </b-form>
    </b-modal>
  </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import VueRecaptcha from 'vue-recaptcha';
import VCalendar from 'v-calendar';
import { saveAs } from 'file-saver';
import moment from 'moment';
import _ from 'lodash';


export default {
  name: 'licence',
  components: { FacitHeader},
  data() {
    return {
      productKey: null,
      PeopleCounterPerspective: 1,
      PeopleCounterOverHead: 1,
      peopleCounterNew: 0,
      heatMap: 1,
      queueManager: 1,
      falseDirection: 1,
      showProducts: false,
      showPeopleCounterOverhead: false,
      notShowPeopleCounterOverhead: false,
      expiryMonth: null,
      licenceType: null,
      storeId: null,
      storeName: null,
      customerName: null,
      country: null,
      installationDate: new Date(),
      goLiveDate: new Date(),
      newInstallationDate: null,
      newGoLiveDate: null,
      userSettingsModal: false,
      licenceId: null,
      licenceUserId: null,
      isDateUpdated: false,
      newStoreId: null,
      licenceUpdateModal:false,
      videoAnalytics: 1,
      updatedAt: new Date(),
      updatedCount: 0,
      commercialOnly: false,
      officeUser: false,
      countries: [
        { value: null, text: 'Select Country' },
        { value: 'Afghanistan', text: 'Afghanistan' },
        { value: 'Åland Islands', text: 'Åland Islands' },
        { value: 'Albania', text: 'Albania' },
        { value: 'Algeria', text: 'Algeria' },
        { value: 'American Samoa', text: 'American Samoa' },
        { value: 'Andorra', text: 'Andorra' },
        { value: 'Angola', text: 'Angola' },
        { value: 'Anguilla', text: 'Anguilla' },
        { value: 'Antarctica', text: 'Antarctica' },
        { value: 'Argentina', text: 'Argentina' },
        { value: 'Armenia', text: 'Armenia' },
        { value: 'Aruba', text: 'Aruba' },
        { value: 'Australia', text: 'Australia' },
        { value: 'Austria', text: 'Austria' },
        { value: 'Azerbaijan', text: 'Azerbaijan' },
        { value: 'Bahamas', text: 'Bahamas' },
        { value: 'Bahrain', text: 'Bahrain' },
        { value: 'Bangladesh', text: 'Bangladesh' },
        { value: 'Barbados', text: 'Barbados' },
        { value: 'Belarus', text: 'Belarus' },
        { value: 'Belgium', text: 'Belgium' },
        { value: 'Belize', text: 'Belize' },
        { value: 'Benin', text: 'Benin' },
        { value: 'Bermuda', text: 'Bermuda' },
        { value: 'Bhutan', text: 'Bhutan' },
        { value: 'Bosnia and Herzegovina', text: 'Bosnia and Herzegovina' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Brunei Darussalam', text: 'Brunei Darussalam' },
        { value: 'Bulgaria', text: 'Bulgaria' },
        { value: 'Burkina Faso', text: 'Burkina Faso' },
        { value: 'Burundi', text: 'Burundi' },
        { value: 'Cambodia', text: 'Cambodia' },
        { value: 'Cameroon', text: 'Cameroon' },
        { value: 'Canada', text: 'Canada' },
        { value: 'Central African Republic', text: 'Central African Republic' },
        { value: 'Chad', text: 'Chad' },
        { value: 'Chile', text: 'Chile' },
        { value: 'China', text: 'China' },
        { value: 'Colombia', text: 'Colombia' },
        { value: 'Congo', text: 'Congo' },
        { value: 'Cook Islands', text: 'Cook Islands' },
        { value: 'Costa Rica', text: 'Costa Rica' },
        { value: 'Côte d`Ivoire', text: 'Côte d`Ivoire' },
        { value: 'Croatia', text: 'Croatia' },
        { value: 'Cuba', text: 'Cuba' },
        { value: 'Cyprus', text: 'Cyprus' },
        { value: 'Czech Republic', text: 'Czech Republic' },
        { value: 'Denmark', text: 'Denmark' },
        { value: 'Dominica', text: 'Dominica' },
        { value: 'Dominican Republic', text: 'Dominican Republic' },
        { value: 'Ecuador', text: 'Ecuador' },
        { value: 'Egypt', text: 'Egypt' },
        { value: 'Eritrea', text: 'Eritrea' },
        { value: 'Estonia', text: 'Estonia' },
        { value: 'Ethiopia', text: 'Ethiopia' },
        { value: 'Fiji', text: 'Fiji' },
        { value: 'Finland', text: 'Finland' },
        { value: 'France', text: 'France' },
        { value: 'Gabon', text: 'Gabon' },
        { value: 'Gambia', text: 'Gambia' },
        { value: 'Georgia', text: 'Georgia' },
        { value: 'Germany', text: 'Germany' },
        { value: 'Ghana', text: 'Ghana' },
        { value: 'Gibraltar', text: 'Gibraltar' },
        { value: 'Greece', text: 'Greece' },
        { value: 'Greenland', text: 'Greenland' },
        { value: 'Grenada', text: 'Grenada' },
        { value: 'Guadeloupe', text: 'Guadeloupe' },
        { value: 'Guam', text: 'Guam' },
        { value: 'Guatemala', text: 'Guatemala' },
        { value: 'Guernsey', text: 'Guernsey' },
        { value: 'Guinea', text: 'Guinea' },
        { value: 'Guinea-Bissau', text: 'Guinea-Bissau' },
        { value: 'Guyana', text: 'Guyana' },
        { value: 'Haiti', text: 'Haiti' },
        { value: 'Honduras', text: 'Honduras' },
        { value: 'Hong Kong', text: 'Hong Kong' },
        { value: 'Hungary', text: 'Hungary' },
        { value: 'Iceland', text: 'Iceland' },
        { value: 'India', text: 'India' },
        { value: 'Indonesia', text: 'Indonesia' },
        { value: 'Islamic Republic of Iran', text: 'Islamic Republic of Iran' },
        { value: 'Iraq', text: 'Iraq' },
        { value: 'Ireland', text: 'Ireland' },
        { value: 'Israel', text: 'Israel' },
        { value: 'Italy', text: 'Italy' },
        { value: 'Jamaica', text: 'Jamaica' },
        { value: 'Japan', text: 'Japan' },
        { value: 'Jersey', text: 'Jersey' },
        { value: 'Jordan', text: 'Jordan' },
        { value: 'Kazakhstan', text: 'Kazakhstan' },
        { value: 'Kenya', text: 'Kenya' },
        { value: 'Kiribati', text: 'Kiribati' },
        { value: 'Democratic People`s Republic of Korea', text: 'Democratic People`s Republic of Korea' },
        { value: 'Republic of Korea', text: 'Republic of Korea' },
        { value: 'Kuwait', text: 'Kuwait' },
        { value: 'Kyrgyzstan', text: 'Kyrgyzstan' },
        { value: 'Latvia', text: 'Latvia' },
        { value: 'Lebanon', text: 'Lebanon' },
        { value: 'Lesotho', text: 'Lesotho' },
        { value: 'Liberia', text: 'Liberia' },
        { value: 'Libya', text: 'Libya' },
        { value: 'Liechtenstein', text: 'Liechtenstein' },
        { value: 'Lithuania', text: 'Lithuania' },
        { value: 'Luxembourg', text: 'Luxembourg' },
        { value: 'Macao', text: 'Macao' },
        { value: 'Madagascar', text: 'Madagascar' },
        { value: 'Malawi', text: 'Malawi' },
        { value: 'Malaysia', text: 'Malaysia' },
        { value: 'Maldives', text: 'Maldives' },
        { value: 'Mali', text: 'Mali' },
        { value: 'Malta', text: 'Malta' },
        { value: 'Marshall Islands', text: 'Marshall Islands' },
        { value: 'Martinique', text: 'Martinique' },
        { value: 'Mauritania', text: 'Mauritania' },
        { value: 'Mauritius', text: 'Mauritius' },
        { value: 'Mayotte', text: 'Mayotte' },
        { value: 'Mexico', text: 'Mexico' },
        { value: 'Micronesia', text: 'Micronesia' },
        { value: 'Moldova', text: 'Moldova' },
        { value: 'Monaco', text: 'Monaco' },
        { value: 'Mongolia', text: 'Mongolia' },
        { value: 'Montenegro', text: 'Montenegro' },
        { value: 'Montserrat', text: 'Montserrat' },
        { value: 'Morocco', text: 'Morocco' },
        { value: 'Mozambique', text: 'Mozambique' },
        { value: 'Myanmar', text: 'Myanmar' },
        { value: 'Namibia', text: 'Namibia' },
        { value: 'Nauru', text: 'Nauru' },
        { value: 'Nepal', text: 'Nepal' },
        { value: 'Netherlands', text: 'Netherlands' },
        { value: 'New Caledonia', text: 'New Caledonia' },
        { value: 'New Zealand', text: 'New Zealand' },
        { value: 'Nicaragua', text: 'Nicaragua' },
        { value: 'Niger', text: 'Niger' },
        { value: 'Nigeria', text: 'Nigeria' },
        { value: 'Niue', text: 'Niue' },
        { value: 'Norfolk Island', text: 'Norfolk Island' },
        { value: 'Northern Mariana Islands', text: 'Northern Mariana Islands' },
        { value: 'Norway', text: 'Norway' },
        { value: 'Oman', text: 'Oman' },
        { value: 'Pakistan', text: 'Pakistan' },
        { value: 'Palau', text: 'Palau' },
        { value: 'Palestine', text: 'Palestine' },
        { value: 'Panama', text: 'Panama' },
        { value: 'Papua New Guinea', text: 'Papua New Guinea' },
        { value: 'Paraguay', text: 'Paraguay' },
        { value: 'Peru', text: 'Peru' },
        { value: 'Philippines', text: 'Philippines' },
        { value: 'Pitcairn', text: 'Pitcairn' },
        { value: 'Poland', text: 'Poland' },
        { value: 'Portugal', text: 'Portugal' },
        { value: 'Puerto Rico', text: 'Puerto Rico' },
        { value: 'Qatar', text: 'Qatar' },
        { value: 'Réunion', text: 'Réunion' },
        { value: 'Romania', text: 'Romania' },
        { value: 'Russian Federation', text: 'Russian Federation' },
        { value: 'Rwanda', text: 'Rwanda' },
        { value: 'Saint Barthélemy', text: 'Saint Barthélemy' },
        { value: 'Saint Helena', text: 'Saint Helena, Ascension and Tristan da Cunha' },
        { value: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
        { value: 'Saint Lucia', text: 'Saint Lucia' },
        { value: 'Saint Pierre and Miquelon', text: 'Saint Pierre and Miquelon' },
        { value: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
        { value: 'Samoa', text: 'Samoa' },
        { value: 'San Marino', text: 'San Marino' },
        { value: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
        { value: 'Saudi Arabia', text: 'Saudi Arabia' },
        { value: 'Senegal', text: 'Senegal' },
        { value: 'Serbia', text: 'Serbia' },
        { value: 'Seychelles', text: 'Seychelles' },
        { value: 'Sierra Leone', text: 'Sierra Leone' },
        { value: 'Singapore', text: 'Singapore' },
        { value: 'Sint Maarten', text: 'Sint Maarten' },
        { value: 'Slovakia', text: 'Slovakia' },
        { value: 'Slovenia', text: 'Slovenia' },
        { value: 'Solomon Islands', text: 'Solomon Islands' },
        { value: 'Somalia', text: 'Somalia' },
        { value: 'South Africa', text: 'South Africa' },
        { value: 'South Sudan', text: 'South Sudan' },
        { value: 'Spain', text: 'Spain' },
        { value: 'Sri Lanka', text: 'Sri Lanka' },
        { value: 'Sudan', text: 'Sudan' },
        { value: 'Suriname', text: 'Suriname' },
        { value: 'Swaziland', text: 'Swaziland' },
        { value: 'Sweden', text: 'Sweden' },
        { value: 'Switzerland', text: 'Switzerland' },
        { value: 'Syrian Arab Republic', text: 'Syrian Arab Republic' },
        { value: 'Taiwan', text: 'Taiwan' },
        { value: 'Tajikistan', text: 'Tajikistan' },
        { value: 'Tanzania', text: 'Tanzania' },
        { value: 'Thailand', text: 'Thailand' },
        { value: 'Timor-Leste', text: 'Timor-Leste' },
        { value: 'Togo', text: 'Togo' },
        { value: 'Tokelau', text: 'Tokelau' },
        { value: 'Tonga', text: 'Tonga' },
        { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
        { value: 'Tunisia', text: 'Tunisia' },
        { value: 'Turkey', text: 'Turkey' },
        { value: 'Turkmenistan', text: 'Turkmenistan' },
        { value: 'Tuvalu', text: 'Tuvalu' },
        { value: 'Uganda', text: 'Uganda' },
        { value: 'Ukraine', text: 'Ukraine' },
        { value: 'United Arab Emirates', text: 'United Arab Emirates' },
        { value: 'United Kingdom', text: 'United Kingdom' },
        { value: 'United States', text: 'United States' },
        { value: 'Uruguay', text: 'Uruguay' },
        { value: 'Uzbekistan', text: 'Uzbekistan' },
        { value: 'Vanuatu', text: 'Vanuatu' },
        { value: 'Venezuela', text: 'Venezuela' },
        { value: 'Viet Nam', text: 'Viet Nam' },
        { value: 'Virgin Islands, British', text: 'Virgin Islands, British' },
        { value: 'Virgin Islands, U.S.', text: 'Virgin Islands, U.S.' },
        { value: 'Wallis and Futuna', text: 'Wallis and Futuna' },
        { value: 'Western Sahara', text: 'Western Sahara' },
        { value: 'Yemen', text: 'Yemen' },
        { value: 'Zambia', text: 'Zambia' },
        { value: 'Zimbabwe', text: 'Zimbabwe' },
      ],
      options: [
        {id: 1, type: "Demo License"},
        {id:2, type: "Commercial License"}
      ],
      commercialOptions: [
        {id: 1, type: "Demo License"},
        {id:2, type: "Commercial License"}
      ],
      expiryOptions: [
        {id:6, days: "6 Months"},
        {id: 36, days: "3 Years"},
        {id: 60, days: "5 Years"}
      ],
      expiryOptions2: [
        {id:6, days: "6 Months"},
        {id: 36, days: "3 Years"},
        {id: 60, days: "5 Years"},
        {id: 120, days: "Life Time"}
      ],
      licence: [],
      fields: [
        {
          key: 'customerName',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'storeId',
          label: 'Store Id',
          sortable: true,
        },
        {
          key: 'storeName',
          label: 'Store Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'productKey',
          label: 'Product Key',
          sortable: true,
        },
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'expiryDate',
          label: 'Expiry Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'download',
          label: 'License Key',
          sortable: false,
          class: 'text-center'
        },
      ],
      fields2: [
        {
          key: 'customerName',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'storeId',
          label: 'Store Id',
          sortable: true,
        },
        {
          key: 'storeName',
          label: 'Store Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'productKey',
          label: 'Product Key',
          sortable: true,
        },
        {
          key: 'licenceType',
          label: 'License Type',
          sortable: true,
          formatter: (value) => {
            if (value === 1) {
              return 'Demo';
            } else {
              return 'Commercial';
            }

          },
        },
        {
          key: 'installationDate',
          label: 'Installation Date',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'goLiveDate',
          label: 'Go Live Date',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'expiryDate',
          label: 'Expiry Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'download',
          label: 'License Key',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
          class: 'text-center'
        },
      ],
      fields3: [
        {
          key: 'customerName',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'storeId',
          label: 'Store Id',
          sortable: true,
        },
        {
          key: 'storeName',
          label: 'Store Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: true,
        },
        {
          key: 'productKey',
          label: 'Product Key',
          sortable: true,
        },
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            return moment(value).format('DD-MM-YYYY');
          },
        },
        {
          key: 'download',
          label: 'License Key',
          sortable: false,
          class: 'text-center'
        },
      ],
    };
  },
  created() {
    let emailAddress = Session.getAccessToken().user.email
    emailAddress = emailAddress.toLowerCase()
    if (emailAddress === 'me.asadshah@gmail.com' || emailAddress === 'orders@qognify.com') {
      this.showProducts = true
    }
    if (emailAddress === 'me_asadshah@hotmail.com' || emailAddress === 'support@vi2vi-retail-solution.com') {
      this.showPeopleCounterOverhead = true
      this.notShowPeopleCounterOverhead = false
      this.heatMap = 0
      this.PeopleCounterPerspective = 0
      this.queueManager = 0
      this.falseDirection = 0
      this.peopleCounterNew = 1
    }
    if (emailAddress === 'manfred.derr@simplysol.de') {
      this.commercialOnly = true
      this.heatMap = 0
      this.queueManager = 0
      this.falseDirection = 0
    }
    if (emailAddress === 'g.fierro@es-sicherheit.ch' || emailAddress === 'asadriaz.shah@outlook.com') {
      this.notShowPeopleCounterOverhead = true
      this.heatMap = 0
      this.PeopleCounterPerspective = 0
      this.PeopleCounterOverHead = 0
      this.queueManager = 0
      this.falseDirection = 0
      this.peopleCounterNew = 1
    }
    if (emailAddress === 'awais@facitdatasystems.com' || emailAddress === 'waqas16@gmail.com') {
      this.officeUser = true
      this.peopleCounterNew = 1
    }
    const customMessage = {
    custom: {
      productKey: {
        required: 'The Product Key Field is Required',
      },
      licenceType: {
        required: 'License Type is Required',
      },
      expiryMonth: {
        required: 'Select License Expiry Duration',
      },
      customerName: {
        required: 'Customer Name Field is Required',
      },
      storeName: {
        required: 'Store Name Field is Required',
      },
      storeId: {
        required: 'Store Id Field is Required',
      },
      installationDate: {
        required: 'Installation Date is Required'
      },
      goLiveDate: {
        required: 'Go Live Date is Required'
      }
    },
  };
  this.$validator.localize('en', customMessage);
  this.getLicence();
  },
  methods: {
    async getLicence() {
      const id = Session.getAccessToken().user.id;
      const downloads = await API.get(`Accounts/${id}/Licence?filter={"where": {"cancelled": false}}`);
      this.licence = _.orderBy(downloads, ['id'], ['desc'])
    },
    async demoLicence(scope) {
      try {
        const user = Session.getAccessToken().user;
        const id = user.id;
        let emailAddress = user.email;
        emailAddress = emailAddress.toLowerCase();
        const firstName = user.firstname;
        const lastName = user.lastname;
        const validation = await this.$validator.validateAll(scope);
        let expiryMonth = 1
        let licenceType = 1

        if (this.showProducts) {
          this.PeopleCounterOverHead = this.videoAnalytics
          this.heatMap = this.videoAnalytics
          this.PeopleCounterPerspective = this.videoAnalytics
          this.queueManager = this.videoAnalytics
          this.falseDirection = this.videoAnalytics
        }
        if (this.licenceType && this.licenceType.id === 2 && !this.commercialOnly) {
          expiryMonth = this.expiryMonth.id
          licenceType = this.licenceType.id
        }
        if (this.commercialOnly) {
          expiryMonth = 120
          licenceType = this.licenceType.id
        }
        if (validation) {
        const licence = await API.post(`Accounts/licenceKey`, {
          userId: id,
          productKey: this.productKey,
          peopleCounterPerspective: this.PeopleCounterPerspective,
          peopleCounterOverHead: this.PeopleCounterOverHead,
          peopleCounterNew: this.peopleCounterNew,
          heatMap: this.heatMap,
          queueManager: this.queueManager,
          falseDirection: this.falseDirection,
          expiryMonth: expiryMonth,
          licenceType: licenceType,
          firstName: firstName,
          lastName: lastName,
          emailAddress: emailAddress,
          storeId: this.storeId,
          storeName: this.storeName,
          country: this.country,
          customerName: this.customerName,
          installationDate: this.installationDate,
          isDateUpdated: true,
          goLiveDate: this.goLiveDate,
        });
        if (licence) {
          throw licence
        }
        this.getLicence();
      }
      } catch (error) {
        const message = error.message;
        if (message.match(/Invalid Product Key/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Invalid Product Key',
          });
        }
      }
    },
    async getDetail(id,userId) {
      const licenceDetail = await API.get(`Accounts/${userId}/Licence/${id}`);
      this.newInstallationDate = moment(licenceDetail.installationDate).toDate();
      this.newGoLiveDate = moment(licenceDetail.goLiveDate).toDate();
      this.licenceId = id;
      this.isDateUpdated = licenceDetail.isDateUpdated
      this.licenceUserId = userId;
      this.newStoreId = licenceDetail.storeId;
      this.userSettingsModal = true;
      this.updatedCount = licenceDetail.updatedCount + 1;
    },
    async updateInstallationDate() {
      try {
        const currentDate = new Date();
        const installationDate = moment(this.newInstallationDate).format('YYYY-MM-DD hh:mm:ss');
        const newInstallationDate = new Date(installationDate);
        const installationTimeDiff = Math.abs(newInstallationDate.getTime() - currentDate.getTime());
        const installationDiff = Math.round(installationTimeDiff / (1000 * 3600 * 24));
        let status = ''
        if (installationDiff === 0) {
          status = 'In Progress'
        } else if (installationDiff >0) {
          status = 'Pre Install'
        }
        //if (this.isDateUpdated) {
          await API.put(`Accounts/${this.licenceUserId}/Licence/${this.licenceId}`, {
            installationDate: moment(this.newInstallationDate).format('YYYY-MM-DD'),
            isDateUpdated: false,
            goLiveDate: moment(this.newGoLiveDate).format('YYYY-MM-DD'),
            storeId: this.newStoreId,
            currentStatus: status,
            updatedCount: this.updatedCount,
            updatedAt: this.updatedAt,
          });
        // } else {
        //   await API.put(`Accounts/${this.licenceUserId}/Licence/${this.licenceId}`, {
        //     storeId: this.newStoreId,
        //   });
        // }

        this.getLicence();
        this.userSettingsModal = false;
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while update',
        });
      }
    },
    async generateLicence(LicenceKey) {
      const blob = new Blob([LicenceKey], {type: "text/plain;charset=utf-8"});
      saveAs(blob, "Product Id.lic");
    },
    async onVerify(response) {
      if (response) {
        this.disabledButton = false;
      }
    },
    onExpired() {

    },
    redirect() {
      this.$router.push('/');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
table > thead {
    display:none !important;
}
.table {
  width: 90% !important;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/licence.vue